module.exports = "/images/extreme-heat@3x.png?c9275c6a970bca5dc0eafd18da10d4eb";